var map = {
	"../pages/add-edit-events/add-edit-events.module": [
		1147,
		14
	],
	"../pages/add-message/add-message.module": [
		1161,
		13
	],
	"../pages/add-tasks/add-tasks.module": [
		1148,
		12
	],
	"../pages/advalvas/advalvas.module": [
		1149,
		11
	],
	"../pages/agenda/agenda.module": [
		1150,
		10
	],
	"../pages/dashboard/dashboard.module": [
		1159,
		9
	],
	"../pages/login/login.module": [
		1151,
		8
	],
	"../pages/message-info/message-info.module": [
		1152,
		7
	],
	"../pages/message-template/message-template.module": [
		1160,
		6
	],
	"../pages/messages/messages.module": [
		1153,
		5
	],
	"../pages/tabs/tabs.module": [
		1154,
		4
	],
	"../pages/task-detail/task-detail.module": [
		1155,
		3
	],
	"../pages/tasks/tasks.module": [
		1156,
		2
	],
	"../pages/user-profile/user-profile.module": [
		1157,
		1
	],
	"../pages/users/users.module": [
		1158,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 312;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 312
// module chunks = 15